/**
 * Queue Domain - Arabic Translations
 */

import type { QueueTranslations } from './en'

export const ar: QueueTranslations = {
  queue: {

    // Queue simulation (read-only sandbox over the live yard)
    simBaseline: 'الحالي',
    simOnItsWay: 'في الطريق',
    simIdle: 'خامل',
    simStatWaiting: 'في الانتظار',
    simStatDone: 'حُمّلت',
    simStatWorst: 'أطول انتظار',
    simModeLive: 'الساحة الآن',
    simModeReplay: 'إعادة يوم سابق',
    simModeBlank: 'بناء يوم',
    simModeLiveHint: 'ابدأ من الشاحنات الموجودة فعليًا في الطابور الآن.',
    simModeReplayHint: 'شاحنات حقيقية بأوقات وصول وتحميل حقيقية من وردية حدثت فعلًا.',
    simModeBlankHint: 'أرصفة وإعدادات حقيقية بلا شاحنات. أنت تختار الطلبات.',
    simPickADay: 'اختر يومًا',
    simDayTrucks: '{{trucks}} شاحنة',
    simNoDays: 'لا توجد أيام سابقة بحركة كافية للإعادة.',
    simPlay: 'تشغيل',
    simPause: 'إيقاف',
    simStep: 'الخطوة التالية',
    simAddTrucks: 'أدخل شاحنات',
    simAddN: 'أدخل {{count}}',
    simStart: 'ابدأ',
    simStarting: 'جارٍ تحميل الساحة…',
    simHowItEnded: 'كيف انتهى اليوم',
    simDayComplete: 'تم تحميل جميع الشاحنات.',
    simTheTrade: 'اقرأ الصفّين معًا. مكسب التجميع في أسوأ الحالات، وثمنه في الوسط.',
    simTitle: 'محاكي الطابور',
    simSubtitle: 'جرّب تغييرًا على الساحة كما هي الآن. لا يُحفظ أي شيء هنا.',
    simSubtitleFactory: '{{factory}} — الساحة كما هي الآن. لا يُحفظ أي شيء هنا.',
    simReadOnlyNotice: 'هذه بيئة تجريبية. تقرأ الساحة الحقيقية وتحسب ما سيحدث — لا يُغلق أي رصيف، ولا يُستدعى أي سائق، ولا يتغيّر أي طابور.',
    simBays: 'الأرصفة',
    simNoBays: 'لا توجد أرصفة نشطة لهذا المصنع.',
    simProductLines: 'طوابير المنتجات',
    simNoOneWaiting: 'لا أحد في الانتظار.',
    simWaitingAnyBay: '{{count}} في الانتظار · أي رصيف يستطيع التحميل',
    simAlsoTakes: 'وأيضًا',
    simOpen: 'مفتوح',
    simClosed: 'مغلق',
    simNotLoading: 'لا يحمّل',
    simEmptySlot: 'فارغ',
    simCalledExpires: 'تم الاستدعاء · {{minutes}} د للحضور',
    simBoundWaiting: 'مرتبطة وفي الانتظار ({{count}})',
    simSendAnOrder: 'أدخل طلبًا',
    simSearchOrders: 'ابحث برقم الطلب',
    simNoOrders: 'لا توجد طلبات متاحة للإدخال.',
    simNoCustomer: 'بدون عميل',
    simTypicalLoad: 'عادة {{minutes}} د',
    simSendIn: 'إدخال',
    simPlus15: '+15 دقيقة',
    simPlusHour: '+ساعة',
    simUndo: 'تراجع',
    simResetToLive: 'العودة للوضع الحالي',
    simSoFar: 'حتى الآن — {{name}}',
    simChangesMade: 'ما غيّرته ({{count}})',
    simWhatHappened: 'ما الذي حدث',
    simNothingYet: 'لا شيء بعد. قدّم الوقت أو أدخل طلبًا.',
    simWhatThisAssumes: 'ما تفترضه المحاكاة',
    simWhatChanges: 'ما الذي يتغيّر',
    simVs: 'مقابل {{baseline}}',
    simNoMaterialDifference: 'لا فرق جوهري هنا. لا تبنِ عليه قرارًا.',
    simCompareTodayPooled: 'الحالي مقابل المجمّع',
    simCompareTodaySmart: 'الحالي مقابل الرصيف الذكي',
    simCompareAll: 'الثلاثة معًا',
    simCompareTodayOnly: 'الحالي فقط',
    simMetricServed: 'حُمّلت وغادرت',
    simMetricWaiting: 'ما زالت تنتظر',
    simMetricNoShow: 'استُدعيت ولم تحضر',
    simMetricMessages: 'الرسائل المرسلة',
    simMetricMedianWait: 'وسيط الانتظار',
    simMetricP90Wait: '٩ من ١٠ ينتظرون أقل من',
    simMetricWorstWait: 'أطول انتظار',
    simMetricIdleBay: 'دقائق رصيف خامل مع وجود شاحنات منتظرة',
    simMetricOvertakes: 'تجاوزات داخل المنتج نفسه',
    simMetricPreExisting: 'كانت تُحمّل عند البدء',
    simWaitExplainer: 'يحتسب زمن الانتظار الشاحنات التي لم تُستدعَ إطلاقًا على أنها انتظرت طوال الوقت — وإلا لبدا الطابور الذي يهمل الناس جيدًا.',
    // Section Titles
    title: 'إدارة الطابور',
    loadingLocations: 'مواقع التحميل',
    loadingLocationRules: 'قواعد مواقع التحميل',
    loadingLocationRule: 'قاعدة موقع التحميل',
    queueEntries: 'الطابور',
    dashboard: 'لوحة معلومات الطابور',

    // Queue switch (packhouse role)
    queueOpen: 'الطابور مفتوح',
    queueClosed: 'الطابور مغلق',
    bulk: 'جملة',
    bags: 'أكياس',

    // Actions
    addLocation: 'إضافة موقع تحميل',
    editLocation: 'تعديل موقع التحميل',
    deleteLocation: 'حذف موقع التحميل',
    addRule: 'إضافة قاعدة',
    editRule: 'تعديل القاعدة',
    deleteRule: 'حذف القاعدة',
    viewQueue: 'عرض الطابور',
    refreshQueue: 'تحديث الطابور',
    joinQueue: 'الانضمام للطابور',
    cancelEntry: 'إلغاء الإدخال',
    validateEntry: 'التحقق من الدخول',
    recordExit: 'تسجيل الخروج',

    // Rule Form
    ruleForm: {
      section: 'إعدادات القاعدة',
      loadingLocation: 'موقع التحميل',
      selectLoadingLocation: 'اختر موقع التحميل',
      cities: 'المدن',
      customers: 'العملاء',
      selectCities: 'اختر المدن',
      selectCustomers: 'اختر العملاء',
      allCustomers: 'جميع العملاء',
      anyCity: 'أي مدينة',
      priority: 'الأولوية',
      description: 'الوصف',
      descriptionPlaceholder: 'وصف اختياري',
      isActive: 'نشط',
      isActiveHelp: 'تطبيق هذه القاعدة عند مطابقة الطلبات مع المواقع',
    },

    // Rule Fields
    ruleLoadingLocation: 'موقع التحميل',
    ruleCities: 'المدن',
    rulePriority: 'الأولوية',
    ruleDescription: 'الوصف',
    ruleFilterLocation: 'موقع التحميل',
    ruleFilterCity: 'المدينة',

    // Location Form
    locationForm: {
      title: 'تفاصيل موقع التحميل',
      subtitle: 'إعداد نقطة تحميل جديدة لإدارة الطابور',
      sectionIdentity: 'الهوية',
      sectionAssignment: 'التعيين',
      sectionCapacity: 'السعة والعرض',
      label: 'اسم الموقع',
      labelPlaceholder: 'مثال: رصيف 1، صومعة 3',
      locationKind: 'نوع الموقع',
      selectLocationKind: 'اختر النوع',
      locationNumber: 'الرقم',
      locationNumberPlaceholder: '1',
      deviceId: 'معرف الجهاز',
      deviceIdPlaceholder: 'device-bay-01',
      deviceIdHint: 'معرف فريد لجهاز الكشك / الشاشة',
      factory: 'المصنع',
      selectFactory: 'اختر المصنع',
      noFactories: 'لا توجد مصانع متاحة',
      variant: 'المنتج',
      selectVariant: 'اختر المنتج',
      noVariants: 'لا توجد منتجات متاحة',
      allowedVariants: 'منتجات إضافية',
      allowedVariantsHelp: 'اختر المنتجات الإضافية التي يمكن لهذا الموقع التعامل معها',
      primaryVariant: 'المنتج الافتراضي',
      noPrimary: 'بدون تفضيل',
      maxVehicles: 'الحد الأقصى للمركبات',
      maxVehiclesPlaceholder: '2',
      maxVehiclesHelp: 'عدد المركبات المسموح بها داخل الموقع في وقت واحد',
      windowNumber: 'رقم النافذة',
      windowNumberPlaceholder: '0',
      monitorIndex: 'رقم الشاشة',
      monitorIndexPlaceholder: '0',
      isActive: 'نشط',
      isActiveHelp: 'قبول طلبات الانضمام للطابور',
    },

    // Location Kind
    locationKind: {
      bay: 'رصيف',
      silo: 'صومعة',
    },

    // Queue Status
    status: {
      waiting: 'في الانتظار',
      ready: 'جاهز',
      called: 'تم الاستدعاء',
      entered: 'دخل',
      loading: 'جاري التحميل',
      completed: 'مكتمل',
      cancelled: 'ملغي',
      expired: 'منتهي الصلاحية',
      noShow: 'لم يحضر',
      loaded: 'تم التحميل',
    },

    // Event Types
    eventType: {
      queue_joined: 'انضم للطابور',
      status_changed: 'تغيير الحالة',
      notification_sent: 'إرسال إشعار',
      entry_validated: 'التحقق من الدخول',
      entered_factory: 'دخول المصنع',
      entered_loading: 'في نقطة التحميل',
      exited_factory: 'خروج من المصنع',
      slot_released: 'تحرير المكان',
      cancelled: 'ملغي',
    },

    // Statistics
    stats: {
      totalLocations: 'إجمالي المواقع',
      activeLocations: 'المواقع النشطة',
      totalCapacity: 'السعة الإجمالية',
      currentOccupancy: 'الإشغال الحالي',
      totalInQueue: 'في الطابور',
      waitingCount: 'في الانتظار',
      readyCount: 'جاهز للدخول',
      insideCount: 'داخل المصنع',
      availableSlots: 'الأماكن المتاحة',
      queueLength: 'طول الطابور',
      avgWaitTime: 'متوسط وقت الانتظار',
    },

    // Entry Details
    entry: {
      ticketNumber: 'رقم التذكرة',
      queueNumber: 'رقم الطابور',
      orderNumber: 'رقم الطلب',
      position: 'الموقع في الطابور',
      driver: 'السائق',
      phone: 'الهاتف',
      vehicle: 'المركبة',
      order: 'الطلب',
      product: 'المنتج',
      location: 'موقع التحميل',
      requestedAt: 'وقت الطلب',
      notifiedAt: 'وقت الإشعار',
      readySince: 'جاهز منذ',
      enteredAt: 'وقت الدخول',
      exitedAt: 'وقت الخروج',
      waitTime: 'وقت الانتظار',
      totalTime: 'الوقت الإجمالي',
    },

    // Messages
    messages: {
      locationCreated: 'تم إنشاء موقع التحميل بنجاح',
      locationUpdated: 'تم تحديث موقع التحميل بنجاح',
      locationDeleted: 'تم حذف موقع التحميل بنجاح',
      ruleCreated: 'تم إنشاء القاعدة بنجاح',
      ruleUpdated: 'تم تحديث القاعدة بنجاح',
      ruleDeleted: 'تم حذف القاعدة بنجاح',
      joinedQueue: 'تم الانضمام للطابور بنجاح',
      entryAllowed: 'الدخول مسموح - توجه إلى موقع التحميل',
      entryDenied: 'الدخول مرفوض - يرجى الانتظار',
      exitRecorded: 'تم تسجيل الخروج بنجاح',
      entryCancelled: 'تم إلغاء إدخال الطابور',
      queueRefreshed: 'تم تحديث الطابور',
    },

    // Validation
    validation: {
      labelRequired: 'اسم الموقع مطلوب',
      locationKindRequired: 'نوع الموقع مطلوب',
      locationNumberRequired: 'رقم الموقع مطلوب',
      locationNumberInvalid: 'رقم الموقع يجب أن يكون موجبًا',
      deviceIdRequired: 'معرف الجهاز مطلوب',
      deviceIdUnique: 'معرف الجهاز يجب أن يكون فريدًا',
      variantRequired: 'المنتج مطلوب',
      maxVehiclesRequired: 'الحد الأقصى للمركبات مطلوب',
      maxVehiclesInvalid: 'الحد الأقصى للمركبات يجب أن يكون 1 على الأقل',
      orderRequired: 'الطلب مطلوب',
      duplicateEntry: 'الطلب لديه إدخال طابور بالفعل',
      invalidToken: 'رمز الدخول غير صالح',
      notReady: 'غير جاهز للدخول - يرجى الانتظار',
      alreadyEntered: 'دخل المصنع بالفعل',
      notInFactory: 'المركبة ليست في المصنع',
    },

    // Confirmation
    confirm: {
      deleteLocation: 'هل أنت متأكد من حذف موقع التحميل هذا؟',
      deleteLocationWarning:
        'سيتم إزالة الموقع من نظام الطابور. ستتأثر إدخالات الطابور النشطة.',
      cancelEntry: 'هل أنت متأكد من إلغاء إدخال الطابور هذا؟',
      cancelEntryWarning: 'سيحتاج السائق للانضمام للطابور مرة أخرى.',
      deleteRule: 'هل أنت متأكد من حذف هذه القاعدة؟',
      deleteRuleWarning: 'سيؤدي ذلك إلى إزالة القاعدة وقد يتم تعيين الموقع عبر التوزيع التلقائي.',
    },

    // Empty States
    empty: {
      noLocations: 'لم يتم العثور على مواقع تحميل',
      noLocationsDescription: 'أنشئ موقع تحميل لبدء إدارة الطوابير',
      noEntries: 'لم يتم العثور على إدخالات طابور',
      noEntriesDescription: 'ستظهر إدخالات الطابور عند انضمام السائقين',
      noEvents: 'لا توجد أحداث حديثة',
      noEventsDescription: 'سيظهر نشاط الطابور هنا',
      noRules: 'لم يتم العثور على قواعد',
      noRulesDescription: 'أنشئ قاعدة للتحكم في مواقع التحميل المخصصة بناءً على معايير الطلب',
    },

    // Instructions
    instructions: {
      showQrAtGate: 'أظهر رمز QR هذا عند بوابة الدخول',
      waitForNotification: 'انتظر الإشعار عندما تكون جاهزًا للدخول',
      proceedToLocation: 'توجه إلى موقع التحميل المحدد',
      followStaffDirections: 'اتبع توجيهات الموظفين في المصنع',
    },

    // Tooltips
    tooltips: {
      refreshQueue: 'إعادة تقييم مواقع الطابور وإشعار السائقين',
      activeStatus: 'تبديل توفر الموقع',
      maxVehicles: 'الحد الأقصى للمركبات التي يمكن أن تكون في هذا الموقع في نفس الوقت',
      queuePosition: 'الموقع الحالي في الطابور',
    },

    // Error Keys (returned from backend as i18n keys)
    errors: {
      orderNotFound: 'الطلب غير موجود',
      noResourceAssigned: 'لم يتم تعيين مورد للشحنة',
      alreadyInQueue: 'الطلب موجود في قائمة الانتظار بالفعل',
      cityRequired: 'يرجى اختيار المدينة قبل الانضمام إلى الطابور',
      vehiclePlateAlreadyInQueue: 'رقم لوحة هذه المركبة لديه إدخال نشط في قائمة الانتظار بالفعل. يرجى الانتظار حتى يكتمل الإدخال السابق أو يُلغى.',
      noLoadingLocation: 'لا يوجد موقع تحميل متاح',
      sapSalesOrderFailed: 'فشل إنشاء أمر مبيعات SAP. يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
      insufficientContractBalance: 'رصيد العقد غير كافٍ. يرجى التواصل مع مدير حسابك.',
      noActiveContract: 'لا يوجد عقد نشط. يرجى التواصل مع مدير حسابك.',
      noSapMaterialCode: 'خطأ في إعداد المنتج. يرجى التواصل مع مدير حسابك.',
      entryNotFound: 'إدخال قائمة الانتظار غير موجود',
      cannotCancelTerminal: 'لا يمكن إلغاء إدخال مكتمل أو منتهي الصلاحية',
      locationNotFound: 'موقع التحميل غير موجود',
      noActiveQueueEntry: 'تم رفض الدخول — لا يوجد إدخال نشط في قائمة الانتظار لهذه المركبة',
      ticketUsedOrCancelled: 'تم استخدام التذكرة أو إلغاؤها بالفعل',
      ticketExpired: 'انتهت صلاحية التذكرة',
      alreadyInside: 'تم رفض الدخول — المركبة داخل المنشأة بالفعل',
      notReady: 'الفتحة غير متاحة بعد — يرجى الانتظار حتى تتلقى إشعارًا',
      scanFailed: 'فشل المسح — يرجى المحاولة مرة أخرى',
      fetchLocationsFailed: 'فشل تحميل مواقع التحميل',
      fetchLocationFailed: 'فشل تحميل موقع التحميل',
      createLocationFailed: 'فشل إنشاء موقع التحميل',
      updateLocationFailed: 'فشل تحديث موقع التحميل',
      deleteLocationFailed: 'فشل حذف موقع التحميل',
      fetchEntriesFailed: 'فشل تحميل إدخالات قائمة الانتظار',
      fetchEntryFailed: 'فشل تحميل إدخال قائمة الانتظار',
      joinFailed: 'فشل الانضمام إلى قائمة الانتظار',
      cancelFailed: 'فشل إلغاء الإدخال',
      fetchDashboardFailed: 'فشل تحميل لوحة التحكم',
      fetchEventsFailed: 'فشل تحميل الأحداث',
      refreshFailed: 'فشل تحديث قائمة الانتظار',
      createRuleFailed: 'فشل إنشاء القاعدة',
      updateRuleFailed: 'فشل تحديث القاعدة',
      deleteRuleFailed: 'فشل حذف القاعدة',
      fetchRulesFailed: 'فشل تحميل القواعد',
    },

    // Success Keys
    success: {
      welcomeProceed: 'أهلًا! تفضل إلى الرصيف المخصص لك.',
    },

    // Timeline / Audit Log
    timelineTab: 'السجل الزمني',
    timelineEmpty: 'لا يوجد نشاط بعد',
    timelineEmptyDesc: 'ستظهر هنا التغييرات على موقع التحميل.',
    historyTab: 'السجل',
    historyEmpty: 'لا توجد أحداث مسجلة',
    historyEmptyDesc: 'ستظهر هنا أنشطة الطابور لهذا الإدخال.',
  },

  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    close: 'إغلاق',
    search: 'بحث',
    filter: 'تصفية',
    refresh: 'تحديث',
    loading: 'جاري التحميل...',
    noResults: 'لم يتم العثور على نتائج',
    actions: 'الإجراءات',
    status: 'الحالة',
    all: 'الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    yes: 'نعم',
    no: 'لا',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    print: 'طباعة',
    download: 'تنزيل',
    minutes: 'دقائق',
    hours: 'ساعات',
    ago: 'منذ',
  },
}
